import { ReactNode } from "react";
import copy from "copy-to-clipboard";
import { useMessageController } from "./useMessageController.ts";
import { SuccessMessage } from "./Success/SuccessMessage.tsx";

type ShowMessage = (args: { message: string; timeoutMs: number }) => void;

export function CopyableText({
  value,
  copyMessage,
  showMessage,
  title,
  className,
  children,
}: {
  value: string;
  copyMessage: string;
  showMessage?: ShowMessage;
  title?: string;
  className?: string;
  children?: ReactNode;
}) {
  const ownController = useMessageController();
  const ownsToast = showMessage === undefined;
  const notify = showMessage ?? ownController.showMessage;

  return (
    <>
      {ownsToast && (
        <SuccessMessage
          open={ownController.open}
          message={ownController.message}
        />
      )}
      <span
        className={className}
        title={title}
        onClick={() => {
          copy(value);
          notify({ message: copyMessage, timeoutMs: 4000 });
        }}
      >
        {children ?? value}
      </span>
    </>
  );
}
